module.exports = __webpack_public_path__ + "static/media/more_games_id.8915353c.png";